import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

import { getLanguageCode, hasWindow } from '../utils';

import Button from './Button';

const getColorScheme = (color) => {
  switch (color) {
    case 'coral':
      return {
        backgroundColor: 'coral',
        color: 'blueDarker',
      };
    default:
      return {
        backgroundColor: 'blueDarker',
        color: 'coralLight',
      };
  }
};

const CTAAnchor = ({ text, link, colorTheme }) => {
  const isInternalLink = link.url.includes('https://internal');
  const internalAnchor =
    hasWindow() &&
    isInternalLink &&
    `${window.location.pathname}${link.url.replace(/https:\/\/internal/g, '')}`;

  if (!text) {
    return null;
  }

  const { backgroundColor, color } = getColorScheme(colorTheme);

  if (link.link_type === 'Document') {
    return (
      <Link
        to={`${link.lang !== 'en-us' ? `/${getLanguageCode(link.lang)}` : ''}${
          link.url === '/index' ? '/' : link.url
        }`}
      >
        <Button backgroundColor={backgroundColor} color={color}>
          {text}
        </Button>
      </Link>
    );
  }

  if (isInternalLink) {
    return (
      <AnchorLink to={internalAnchor}>
        <Button backgroundColor={backgroundColor} color={color}>
          {text}
        </Button>
      </AnchorLink>
    );
  }

  return (
    <a href={link.url} target={link.target}>
      <Button backgroundColor={backgroundColor} color={color}>
        {text}
      </Button>
    </a>
  );
};

CTAAnchor.defaultProps = {
  colorTheme: 'blueDarker',
};

CTAAnchor.propTypes = {
  text: PropTypes.string.isRequired,
  link: PropTypes.shape({
    link_type: PropTypes.string,
    url: PropTypes.string,
    lang: PropTypes.string,
    target: PropTypes.string,
  }).isRequired,
  colorTheme: PropTypes.string,
};

export default CTAAnchor;
